var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowUpInsideCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.5C8.27614 7.5 8.5 7.72386 8.5 8V14C8.5 14.2761 8.27614 14.5 8 14.5C7.72386 14.5 7.5 14.2761 7.5 14V8C7.5 7.72386 7.72386 7.5 8 7.5Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46967 6.46967C7.76256 6.17678 8.23744 6.17678 8.53033 6.46967L10.5303 8.46967C10.8232 8.76256 10.8232 9.23744 10.5303 9.53033C10.2374 9.82322 9.76256 9.82322 9.46967 9.53033L8 8.06066L6.53033 9.53033C6.23744 9.82322 5.76256 9.82322 5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967L7.46967 6.46967Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17424 4.90923C3.78075 2.79571 5.74216 1.25 8.06329 1.25C10.8595 1.25 13.147 3.49492 13.1509 6.27863C14.7477 6.49013 15.9957 7.84771 15.9957 9.5C15.9957 11.2998 14.5149 12.75 12.7154 12.75C12.3012 12.75 11.9654 12.4142 11.9654 12C11.9654 11.5858 12.3012 11.25 12.7154 11.25C13.7035 11.25 14.4957 10.4544 14.4957 9.5C14.4957 8.54556 13.7035 7.75 12.7154 7.75H12.4009C11.9867 7.75 11.6509 7.41421 11.6509 7V6.28571C11.6509 4.34413 10.0505 2.75 8.06329 2.75C6.27905 2.75 4.80671 4.03934 4.52839 5.71103C4.4705 6.05873 4.17829 6.3192 3.82625 6.33691C2.49224 6.40401 1.4502 7.48051 1.4502 8.78571C1.4502 10.138 2.56259 11.25 3.9534 11.25C4.36762 11.25 4.7034 11.5858 4.7034 12C4.7034 12.4142 4.36762 12.75 3.9534 12.75C1.75123 12.75 -0.0498047 10.9834 -0.0498047 8.78571C-0.0498047 6.85128 1.34618 5.26677 3.17424 4.90923Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpInsideCloud);
export default __webpack_public_path__ + "static/media/icon-arrow-up-inside-cloud.f2af816564134e6b0e1699283ad257f1.svg";
export { ForwardRef as ReactComponent };